var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.limits)?_c('div',[_c('tips-content'),_c('personal-data'),_c('feed-efficiency'),_c('meat-production-cost'),_c('district-ranking')],1):_c('div',{staticStyle:{"background-color":"#fff","border-radius":"5px","padding":"20px"}},[_c('a-empty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }